import API from '../../../../common/http/api.fetch';
import { formatDate } from '../../../../common/utils/util.date';
import { IDS } from './pnp-settings-compliance-report.constants';

export const getDocument = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/compliance-report/docs`,
            method: 'GET',
            params: {
                location: filter.location,
                offset: filter.offset,
                limit: filter.limit,
                report: true,
                documentStatus: filter.documentStatus,
                documentApplicationType: filter.documentApplicationType,
                documentCategory: filter.documentCategory,
                documentType: filter.documentType,
                keyword: filter.keyword,
                createdDateFrom: filter.createdDateFrom ? formatDate(filter.createdDateFrom): null,
                createdDateTo: filter.createdDateTo? formatDate(filter.createdDateTo): null,
                linkWithAccreditation: filter.linkWithAccreditation,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns
            }
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: IDS.pnpComplianceReportGrid,
                items: data.items.map((item) => {
                    return {
                        id: item.id,
                        title: item.title,
                        version: item.version,
                        docNum: item.doc_num,
                        documentApplicationType: item.document_application_type,
                        documentType: item.document_type,
                        documentCategory: item.document_category,
                        approvalDueDate: item.task_due_date,
                        documentDueDate: item.due_date,
                        path: item.path,
                        docStatus: item.doc_status,
                        author: item.author,
                        created_date: item.created_date,
                        location: item.location,
                        linkWithAccreditation: item.is_link_with_accreditation,
                        downloadAllowed: item.download_allowed
                    }
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}
